export default from './BuyerRegistration';



// WEBPACK FOOTER //
// ./src/components/NonAuthSurveyPage/components/BuyerRegistration/index.js